// New NotificationBanner component to render individual banners
import React from "react";
import Banner from "@/components/Common/Banner/Banner";
import {GlobalNotificationDTO} from "@/types/GlobalNotificationDTO";

const alertTypeColors: Record<string, { bgColor: string; textColor: string }> =
  {
    urgent: { bgColor: "#ffe6e6", textColor: "#b10c00" },
    success: { bgColor: "#e6ffe6", textColor: "#007a1f" },
    standard: { bgColor: "#c0e9ff", textColor: "#122377" },
  };

interface NotificationBannerProps {
  alert: GlobalNotificationDTO;
  onClose: (id: string | number, end: string) => void;
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({
  alert,
  onClose,
}) => {
  const {
    id,
    message,
    subject,
    submessage: subMessage,
    alertType,
    end,
  } = alert;

  const { bgColor, textColor } =
    alertTypeColors[(alertType || "standard").toLowerCase()] ||
    alertTypeColors.standard;

  return (
    <Banner
      subject={subject}
      message={message}
      subMessage={subMessage !== undefined ? String(subMessage) : undefined}
      bgColor={bgColor}
      textColor={textColor}
      onClose={() => onClose(id, end)}
    />
  );
};

export default NotificationBanner;
